import { connect } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'
import CaResultsItemSection from 'components/search/results-item/CaResultsItemSection'

const mapStateToProps = (state) => ({
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(CaResultsItemSection)
